export enum RevenueTypeEnum {
  DESPESA = 1,
  RECEITA = 2
}

export const RevenueTypeEnumAll = [
  { key: "Despesa", value: RevenueTypeEnum.DESPESA },
  { key: "Receita", value: RevenueTypeEnum.RECEITA }
];
